export enum ApiStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS'
}